// frontend/src/components/game/managers/MapManager/ActionLinesLayer.jsx
import React, { useMemo } from 'react';
import useGameStore from '@store/useGameStore';
import { TILE_SIZE } from '@utils/constants';
import PlannedActionLine from '@components/ui/game/planned-action/PlannedActionLine';
import { getTeamColors } from '@utils/cssVariables';
import './ActionLinesLayer.css';

const ActionLinesLayer = () => {
  // Check game status - no action lines during deployment
  const game = useGameStore.getState().game;
  if (!game || game.status === 'game_deploy' || game.status === 'game_lobby') {
    return null; // No action lines during deployment or lobby
  }
  
  // Use getState() to avoid subscription loops - this is a snapshot read
  // Use getHydratedPlannedActions to get full action data including is_movement
  const plannedActions = useGameStore.getState().getHydratedPlannedActions();
  
  // Transform planned actions to line data locally
  const actionLines = useMemo(() => {
    return plannedActions.map(plannedAction => {
      // Skip if no origin or target data
      if (!plannedAction.origin_data || !plannedAction.target_data) {
        console.warn('[ActionLinesLayer] Action missing origin or target data:', plannedAction.id);
        return null;
      }

      // Skip if origin equals target (no movement line needed)
      if (plannedAction.origin_data.x === plannedAction.target_data.x &&
          plannedAction.origin_data.y === plannedAction.target_data.y) {
        return null;
      }

      return {
        id: plannedAction.id,
        order: plannedAction.resolution_order,
        slug: plannedAction.action?.slug,
        team: plannedAction.teamClass || 'unknown',
        from: plannedAction.origin_data,
        to: plannedAction.target_data,
        action: plannedAction, // Pass the complete action data
      };
    }).filter(Boolean);
  }, [plannedActions]);

  if (!actionLines || actionLines.length === 0) {
    return null;
  }

  // ✅ Resolver colores CSS para usar en SVG
  const teamColors = getTeamColors();

  return (
    <div className="map-layer action-lines-layer">
      {actionLines.map((line) => {
        const fromX = line.from.x * TILE_SIZE + TILE_SIZE / 2;
        const fromY = line.from.y * TILE_SIZE + TILE_SIZE / 2;
        const toX = line.to.x * TILE_SIZE + TILE_SIZE / 2;
        const toY = line.to.y * TILE_SIZE + TILE_SIZE / 2;
        const color = teamColors[line.team] || '#FFFFFF';
        
        return (
          <PlannedActionLine
            key={`line-${line.id}-${line.order}`}
            fromX={fromX}
            fromY={fromY}
            toX={toX}
            toY={toY}
            order={line.order}
            color={color}
            actionSlug={line.slug}
            actionId={line.id}
            action={line.action}
          />
        );
      })}
    </div>
  );
};

export default ActionLinesLayer;